import { Injectable } from '@angular/core';

@Injectable()
export class SncPrivacyNoticeService {

  public chaves: Array<any>;

  constructor() {
    this.chaves = new Array<any>();
  }

  public recoveryPrivacyNoticeLocalStorage() {
    Object.keys(localStorage).forEach((keyLocalStorage) => {
      if(keyLocalStorage.includes("aviso-politica-privacidade")) {
        this.chaves.push({
          key: keyLocalStorage,
          value: localStorage.getItem(keyLocalStorage)
        });
      }
    });
  }

  public savePrivacyNoticeLocalStorage() {
    this.chaves.forEach(chave => {
      localStorage.setItem(chave.key, chave.value);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/custom/snc-privacy-notice/snc-privacy-notice.service.ts